jQuery(document).ready(function($) {
	const menu = new Mmenu( ".mobile-navigation-menu", {
		extensions: [
			"position-back",
			"position-right",
		],
		navbars: [],
		screenReader: {
			aria: true,
			text: true,
		},
	} )

	const menuToggleButton = document.querySelector( ".mobile-menu-button" )
	if ( menuToggleButton ) {
		menuToggleButton.addEventListener( "click", () => {
			if ( document.querySelector( ".mobile-navigation-menu" ).classList.contains( "mm-menu_opened" ) ) {
				menu.API.close()
			}
			else {
				menu.API.open()
			}
		} )
	}

	// Apply FitVids to YouTube videos
	if ($("body").innerWidth() <= 767) {
		$(".inside-content-beckground").fitVids({ ignore: "nofit" });
	}

	// Main nav drop-down menus
	if (navigator.userAgent.match(/iPad/i) != null) {
		$(".hasChildren > .nav-drop-toggle-link").click(function(event) {
			if (!$(this).parents(".hasChildren").hasClass("open")) {
				$(".nav-drop-wrap").removeClass("open");
				event.preventDefault();
				$(this).parent(".hasChildren").addClass("open");
			}
		});
	}
	else {
		$(".nav-drop-wrap").hover(function() {
			$(this).addClass("open");
		}, function() {
			$(this).removeClass("open");
		});
	}

	// Accessible menu
	$(".accessible-navigation-menu").accessibleMenu();


	// Landing pages
	document.querySelectorAll('.box-with-icon').forEach((el, index) => {
		el.style.setProperty('--index', index);
	});


	document.querySelectorAll('.c-autotabs_link').forEach((el, index) => {
		el.addEventListener( "click", () => {
			const activeTab = el.getAttribute("data-w-tab")

			// Tab buttons
			document.querySelectorAll(".c-autotabs_link").forEach(tab => {
				tab.classList.toggle("w--current", tab.getAttribute("data-w-tab") === activeTab);
			});

			// Tab content
			document.querySelectorAll(".c-autotabs_pane").forEach(tab => {
				tab.classList.toggle("w--tab-active", tab.getAttribute("data-w-tab") === activeTab);
			});
		})
	});
} )
